module.exports = __webpack_public_path__ + "img/batch-m.09d381f0.png";